export function saveCart(object : Object) {
    localStorage.setItem("cart", JSON.stringify(object));
}

export function getCart() {
    const cart = localStorage.getItem("cart");
    if(cart)
        return JSON.parse(localStorage.getItem("cart"));
    else {
        localStorage.setItem("cart", JSON.stringify([]));

    }
}

export function getPassword() {
    return localStorage.getItem("password") || "";
}

export function setPassword(value : string) {
    return localStorage.setItem("password",value);
}